import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';

import { AlarmsEffects } from './alarms.effects';


export const effects = [AlarmsEffects];

@NgModule({
  imports: [EffectsModule.forFeature(effects)]
})
export class AlarmsEffectsModule {}
